import Main from './DocumentsMain'
import New from './DocumentsNew'
import Edit from './DocumentsEdit'
import Show from './DocumentsShow'
import Comparator from './DocumentComparator'
import FolderMain from './FolderMain'

export default {
  Main,
  New,
  Edit,
  Show,
  Comparator,
  FolderMain,
}
